import { render } from "./project-involved-button.vue?vue&type=template&id=806ee4fc"
import script from "./project-involved-button.vue?vue&type=script&lang=js"
export * from "./project-involved-button.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__